export const BADGE_PRIMARY_COLOR = '#8950fc';
export const BADGE_LOCKED_BG = '#f3f6f9';
export const BADGE_LOCKED_ICON = '#a1a5b7';

export const TIER_COLORS: { [tier: string]: string } = {
  Beginner: '#37c0b8',
  Intermediate: '#3694ff',
  Advanced: '#ffa300',
  Sensei: '#d73545',
  HiddenLegend: '#f5c542',
  Bronze: '#cd7f32',
  Silver: '#a8a9ad',
  Gold: '#d4af37',
};

const KNOWN_ICON_KEYS = [
  'award',
  'book',
  'briefcase',
  'bug',
  'bullseye',
  'calendar-event',
  'chat-dots',
  'code-slash',
  'collection-play',
  'emoji-smile',
  'gem',
  'heart',
  'journal-code',
  'lightning',
  'mortarboard',
  'people',
  'puzzle',
  'slash-lg',
  'star',
  'trophy',
];

export function badgeIconClass(iconKey: string | undefined): string {
  return 'bi-' + (iconKey && KNOWN_ICON_KEYS.indexOf(iconKey) !== -1 ? iconKey : 'award');
}

export function tierColor(tier: string | undefined): string {
  return (tier && TIER_COLORS[tier]) || BADGE_PRIMARY_COLOR;
}
